import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import dayjs, { Dayjs } from 'dayjs'
import { DatepickerRange } from '@shared/models/datepicker-range.model'

export interface DateRange {
  from: Dayjs
  to: Dayjs
}

@Component({
  selector: 'lin-date-range-upd',
  templateUrl: `./date-range-upd.component.html`,
  styleUrls: ['./date-range-upd.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateRangeUpdComponent implements OnInit {
  form: FormGroup

  @Input() dateFrom: Dayjs
  @Input() dateTo: Dayjs
  @Input() isDisabled: boolean
  @Input() isLoading: boolean
  @Input() label: string
  @Output() dateRangeChange = new EventEmitter<DateRange>()

  private startOfPastMonth = dayjs().tz().subtract(1, 'month').startOf('month').startOf('day')
  private endOfPastMonth = dayjs().tz().subtract(1, 'month').endOf('month').endOf('day')

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      selected: {},
    })
  }

  ngOnInit(): void {
    this.form.setValue({
      selected: {
        startDate: this.dateFrom || this.startOfPastMonth,
        endDate: this.dateTo || this.endOfPastMonth,
      },
    })

    this.form.markAsDirty()
  }

  getValue(): DateRange {
    const {
      selected: { startDate: from, endDate: to },
    } = this.form.value as { selected: DatepickerRange<Dayjs> }
    return { from, to: to || to?.clone().endOf('day') }
  }

  updateSearch(): void {
    this.dateRangeChange.emit(this.getValue())
  }

  onDateRangeChange(dateValues: DatepickerRange<Dayjs>): void {
    this.dateRangeChange.emit({ from: dateValues.startDate, to: dateValues.endDate })
  }
}
